module.exports = __webpack_public_path__ + "img/setting_btn.e4138292.png";